import { Colors, InputSearch, Text } from 'basic-ui-lib';
import useGetLibraryLinks from 'modules/media/services/hooks/useGetLibraryLinks';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

const LinkContent = () => {
  const [data] = useGetLibraryLinks();
  const [searchValue, setSearchValue] = useState('');
  const [filteredLinks, setFilteredLinks] = useState(data?.content || []);

  useEffect(() => {
    if (data?.content) {
      if (searchValue.trim() === '') {
        setFilteredLinks(data.content);
      }
      else {
        const lowerSearch = searchValue.toLowerCase();
        setFilteredLinks(data.content.filter((item) => item.name.toLowerCase().includes(lowerSearch) || item.urlLink.toLowerCase().includes(lowerSearch)));
      }
    }
  }, [searchValue, data]);

  return (
    <Container>
      <InputSearch placeholder='Search link' onChange={(value) => setSearchValue(value)} />
      <Content>
        {filteredLinks.map((item) => (
          <LinkCard key={item.id}>
            <Text body_1 medium left>
              {item.name}
            </Text>
            <Text caption_3 regular left color='neutral.text.3'>
              {item.urlLink}
            </Text>
          </LinkCard>
        ))}
      </Content>
    </Container>
  );
};
export default LinkContent;

const Container = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  gap: 16px;
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const LinkCard = styled.a`
  display: flex;
  flex-direction: column;
  gap: 4px;
  cursor: pointer;
  padding-bottom: 8px;
  border-bottom: 1px solid ${Colors.neutral.border[1]};
`;
